import { BaseApi } from './base.api.js';

export class EntityEventApi extends BaseApi {
    constructor(client) {
        super(client, '/entity-events');
    }
}
